import React, { useState, useEffect } from "react";
import {
    BrowserRouter as Router, Link, NavLink, useLocation
} from "react-router-dom";
import EmergingTechnologyData from '../../../../Data/03-CP-EmergingTechnologySecurity/EmergingTechnologyData.json';
import ReactCardFlip from 'react-card-flip';
const ReadMore = ({ children }) => {
    const text = children;
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
    };

    return (
        <p className="infoText-p">
            {isReadMore ? text.slice(0, 90) : text}
            <span
                onClick={toggleReadMore}
                className="readMore-readLess"
            >
                {/* {isReadMore ? " */}
                ...Read more
                {/* " : " Read less" */}
            </span>
        </p>
    );
};

function EmergingTechnology({emerTech}) {

 const itemsPerPage = 6;
    const [currentPage, setCurrentPage] = useState(1);
    const [currentItems, setCurrentItems] = useState([]);
    const [isFlipped, setIsFlipped] = useState(null);
    const [flippedCardId, setFlippedCardId] = useState(null);

    useEffect(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        setCurrentItems(emerTech.length ? emerTech.slice(startIndex, endIndex) : 0);
    }, [emerTech, currentPage, itemsPerPage]);

    const totalPages = Math.ceil(emerTech.length ? emerTech.length / itemsPerPage : 0);

    const getPageNumbers = () => {
        const pageNumbers = [];
        for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(
                <button
                    key={i}
                    className={`page-number ${currentPage === i ? 'active' : ''}`}
                    onClick={() => setCurrentPage(i)}
                >
                    {i}
                </button>
            );
        }
        return pageNumbers;
    };
    const showPagination = emerTech.length > itemsPerPage;

    return (
        <>

            <div className="tabInsidePageWrap">

                <div className="contentHeader">
                </div>
                <div className="innerTabCourse-row">
                    {
                      currentItems.length && currentItems.map((course, index) => {
                            return (
                                <>
                                    <ReactCardFlip key={index} isFlipped={flippedCardId === index} flipDirection="horizontal">
                                        {/* front card */}
                                        <div className="innerTabCourse-Wrapper">
                                            <h4 className="innerTabCourse-Heading">{course.title}</h4>
                                            {/* <ReadMore>
                                                {course.content}
                                            </ReadMore> */}
                                            <p className="infoText-p">{course.content.slice(0, 90)}<span
                                                onClick={() => setFlippedCardId(flippedCardId === index ? null : index)}
                                                className="readMore-text"
                                            >
                                                ...Read more
                                            </span>
                                            </p>

                                            <div className="course-levelRow">
                                                <div className="levelImageText-wrap">
                                                    <div className="level-image">
                                                        <img src="images/SSA/CourseLevel.png" alt="" className="courseLevelIcon" />
                                                    </div>
                                                    <div className="level-text"><strong>Course Level-</strong><br />{course.level}</div>
                                                </div>
                                                <div className="levelImageText-wrap">
                                                    <div className="level-image">
                                                        <img src="images/SSA/CareerLevel.png" alt="" className="courseLevelIcon" />
                                                    </div>
                                                    <div className="level-text"><strong>Career Levels-</strong><br />{course.target_audience}</div>
                                                </div>
                                            </div>
                                            <div className="course-DurationRow">
                                                <div className="levelImageText-wrap">
                                                    <div className="level-image">
                                                        <img src="images/SSA/Duration.png" alt="" className="courseLevelIcon" />
                                                    </div>
                                                    <div className="level-text"><strong>Duration</strong><br />{course.duration}</div>
                                                </div>
                                                <div className="learningLink">
                                                    <a href={course.wd_link} target="_blank" className="learningBtn">Go to Learning</a>
                                                </div>
                                            </div>
                                        </div>

                                        {/* back card */}
                                        <div className="back-card"
                                            onMouseLeave={() => setFlippedCardId(null)}
                                        >
                                            <h4 className="innerTabCourse-Heading back">{course.title}</h4>
                                            <p className="back-card-text">{course.content}</p>
                                        </div>
                                    </ReactCardFlip>
                                </>
                            )
                        })
                    }
                </div>
                {showPagination && emerTech.length > itemsPerPage && (
                    <div className="pagi-container">
                        <button className="pagi-arrowBtn"
                            onClick={() => setCurrentPage((prevPage) => Math.max(prevPage - 1, 1))}
                            disabled={currentPage === 1}

                        >
                            <img src="images/SSA/Back.png" />
                        </button>
                        <div className="pagenumber-cont">
                            {getPageNumbers()}
                        </div>
                        <button className="pagi-arrowBtn"
                            onClick={() => setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages))}
                            disabled={currentPage === totalPages}

                        >
                            <img src="images/SSA/Next.png" />
                        </button>
                    </div>
                )}
            </div>
        </>
    );
}

export default EmergingTechnology;